import React, { useState } from 'react';
import { TypeAnimation } from 'react-type-animation';
import { motion } from 'framer-motion';

// --- Skills Data ---
const skillsData = {
  "Frontend": ["React", "Next.js", "JavaScript", "TypeScript", "Tailwind CSS", "Framer Motion"],
  "Backend": ["Node.js", "Express.js", "Python", "REST APIs", "Flask"],
  "Databases & Tools": ["MongoDB", "PostgreSQL", "Git & GitHub", "Webflow", "Figma", "VS Code"],
};

const Skills = () => {
  const [showOutput, setShowOutput] = useState(false);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2, delayChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };

  return (
    <section id="skills" className="bg-black grainy py-24 sm:py-32 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-text-primary text-center mb-12 font-heading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          My Toolkit
        </motion.h2>

        {/* Terminal Window */}
        <div className="w-full bg-[#1e1e1e] rounded-xl shadow-2xl border border-white/10 overflow-hidden">
          {/* Terminal Header */}
          <div className="bg-primary p-3 flex items-center gap-2 border-b border-white/10">
            <div className="w-3 h-3 rounded-full bg-red-500"></div>
            <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
            <div className="w-3 h-3 rounded-full bg-green-500"></div>
          </div>

          {/* Terminal Body */}
          <div className="p-6 font-mono text-sm md:text-base text-text-secondary">
            <div className="flex items-center gap-2">
              <span className="text-green-400">DheerajReddy:~$</span>
              <TypeAnimation
                sequence={[
                  './list-skills --all',
                  1500,
                  () => setShowOutput(true), // Trigger output after typing
                ]}
                speed={60}
                cursor={true}
                repeat={0}
                wrapper="span"
              />
            </div>

            {showOutput && (
              <motion.div
                className="mt-4 space-y-4"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
              >
                {Object.entries(skillsData).map(([category, items]) => (
                  <motion.div key={category} variants={itemVariants}>
                    <p>
                      <span className="text-accent font-bold">✅ {category.toUpperCase()}:</span>
                    </p>
                    <p className="pl-4">
                      <span className="text-text-primary">{items.join(', ')}</span>
                    </p>
                  </motion.div>
                ))}
                 <motion.div className="flex items-center gap-2 pt-4" variants={itemVariants}>
                    <span className="text-green-400">DheerajReddy:~$</span>
                    <motion.span 
                      className="w-2 h-5 bg-text-primary"
                      animate={{ opacity: [0, 1, 0] }}
                      transition={{ duration: 1.2, repeat: Infinity }}
                    />
                 </motion.div>
              </motion.div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;